import {BigNumberish, ethers} from 'ethers';
import {PremiumKey, TransactionPayload} from '../types';
import {findBy, getUserData, writeItem} from './db';
export const maticId = '0x89';
import uuid from 'react-native-uuid';
import {generateNewPSSPair, verifySignature} from './ssl';
import {getTransactionById, sendMatic} from './metamask';

export const Prices = {
  Cloud: {1: 20, 12: 400},
  Kiosk: {1: 20, 12: 400},
  WalletProtection: {1: 10, 12: 400},
};

export type priceKeys = keyof typeof Prices;

type TransactionUserIdKey =
  | 'CloudPaymentTransactionId'
  | 'KioskPaymentTransactionId'
  | 'WalletProtectionPaymentTransactionId';

export async function checkTransactionExpires(
  priceType: priceKeys,
  signature: string,
  userHash: string,
  trxId?: string,
) {
  if (!trxId) return false;
  try {
    const trx = await getTransactionById(trxId);
    if (!trx) return false;
    const abiCoder = new ethers.AbiCoder();
    const minedDate = (trx?.block?.date as Date).valueOf();
    const sum = parseFloat(
      ethers.formatEther(trx?.value as BigNumberish),
    );
    const monthAgo = new Date().setMonth(new Date().getMonth() - 1);
    const yearAgo = new Date().setFullYear(
      new Date().getFullYear() - 1,
    );
    const prices = Prices[priceType];
    const pubKeyData = abiCoder.decode(
      ['string'],
      trx?.data as string,
    );
    const payload = JSON.parse(pubKeyData[0]) as TransactionPayload;
    const {publicKey} = payload;

    if (!publicKey) throw 'no_public_key';

    const verified = verifySignature(
      publicKey as JsonWebKey,
      signature,
      userHash,
    );
    if (!verified) {
      return false;
    }

    if (sum === prices[1] && minedDate > monthAgo) return true;
    if (sum === prices[12] && minedDate > yearAgo) return true;
  } catch (err) {
    return false;
  }

  return false;
}

const getPlatformWallet = async () => {
  return '0x6423E6b34Cb86562b3055395cD95A3C2B6C8F13B';
};

export async function getPremiumKey() {
  let [premiumKey] = (await findBy(
    'folderId',
    'premium_keys2',
  )) as PremiumKey[];
  if (!premiumKey || !premiumKey.keyPair) {
    const auctionKeyId = uuid.v4().toString();
    const keyPair =
      (await generateNewPSSPair()) as PremiumKey['keyPair'];
    premiumKey = {
      id: auctionKeyId,
      keyPair,
      folderId: 'premium_keys2',
      isKeyPair: true,
    };
    await writeItem(premiumKey);
  }
  console.info(premiumKey);
  return premiumKey;
}

export async function buyService(
  service: priceKeys,
  months: 1 | 12,
  wallet: string,
) {
  const key = await getPremiumKey();
  const amount = Prices[service][months];
  const user = await getUserData();
  const to = await getPlatformWallet();
  const {publicKey} = key.keyPair;
  const txId = await sendMatic(wallet, to, amount, {
    publicKey,
  });
  const txIdKey = (service +
    'PaymentTransactionId') as TransactionUserIdKey;
  user[txIdKey] = txId;
  await writeItem(user);
  return true;
}
